import React from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { NAV_LINKS } from "../data/site";

export const Footer = () => (
  <footer className="relative bg-navy text-white" data-testid="main-footer">
    <div className="mx-auto max-w-[1400px] px-6 py-20 lg:px-12">
      <div className="grid gap-16 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Logo light />
          <p className="mt-8 max-w-sm text-base leading-relaxed text-slate-300">
            FDA-cleared, ISO 7 certified private label suppository manufacturing —
            handcrafted in a certified cleanroom in Westlake Village, California.
          </p>
          <a
            href="mailto:info@mdlabsca.com"
            data-testid="footer-email"
            className="group mt-8 inline-flex items-center gap-3 text-lg font-medium text-white"
          >
            <Mail className="h-5 w-5 text-clinical" />
            info@mdlabsca.com
            <ArrowUpRight className="h-4 w-4 opacity-0 transition-all duration-200 group-hover:translate-x-0.5 group-hover:opacity-100" />
          </a>
        </div>

        <div className="lg:col-span-3 lg:col-start-8">
          <div className="text-xs font-bold uppercase tracking-[0.24em] text-slate-500">
            Navigate
          </div>
          <ul className="mt-6 space-y-4">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="text-slate-300 transition-colors duration-200 hover:text-white"
                  data-testid={`footer-link-${l.to.replace("/", "")}`}
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-2">
          <div className="text-xs font-bold uppercase tracking-[0.24em] text-slate-500">
            Facility
          </div>
          <p className="mt-6 text-slate-300">
            Westlake Village
            <br />
            California, USA
          </p>
          <div className="mt-6 space-y-2 text-sm text-slate-400">
            <div>FDA 510(k) Cleared</div>
            <div>ISO 14644-1:2015</div>
            <div>cGMP Aligned</div>
          </div>
        </div>
      </div>

      <div className="mt-20 flex flex-col justify-between gap-4 border-t border-white/10 pt-8 text-sm text-slate-500 sm:flex-row">
        <span>© {new Date().getFullYear()} MD Labs. All rights reserved.</span>
        <span className="tracking-wide">mdlabsca.com · B2B Manufacturing Partner</span>
      </div>
    </div>
  </footer>
);

export default Footer;
